import { CLASS_SITUATION_WEEKS } from "./classSituationExportSpec"

export const moduleColumnKey = (m) => `module.${m}`
export const weekColumnKey = (weekKey, leafLabel) => `week.${weekKey}.${leafLabel}`

// Mirrors the TableSituation header order. Leaf keys are what the table/export check for visibility.
export const CLASS_SITUATION_COLUMN_TREE = [
  { key: "className", label: "Class name", locked: true },
  { key: "center", label: "Center" },
  { key: "classLevel", label: "Class level" },
  {
    key: "group.module",
    label: "Module",
    children: ["a", "b"].map((m) => ({ key: moduleColumnKey(m), label: m.toUpperCase() })),
  },
  {
    key: "group.schedule",
    label: "Schedule",
    children: [
      { key: "schedule", label: "Schedule" },
      { key: "status", label: "Class status" },
      { key: "estimateAcsThisMonth", label: "Estimated ACS This Month" },
      { key: "estimateAcsNextMonth", label: "Estimated ACS Next Month" },
      { key: "estimateAcsNext2Month", label: "Estimated ACS Next 2 Month" },
      { key: "lessonStudied", label: "Lesson Studied" },
      { key: "finalFillDate", label: "Final Fill Date" },
      { key: "csoInCharge", label: "EC in charge" },
      { key: "teacher", label: "Teacher(s)" },
      { key: "eppThisMonth", label: "This Month EPP" },
      { key: "eppNextMonth", label: "Next Month EPP" },
      { key: "eppT8", label: "Next 2 Month EPP" },
      { key: "recommendToClose", label: "Recommend to close" },
    ],
  },
  {
    key: "group.event",
    label: "Class situation event",
    children: [
      { key: "eoccDate", label: "EOCC date" },
      { key: "moduleTestDate", label: "Module test date" },
      { key: "unitTestDate", label: "Unit test date" },
    ],
  },
  {
    key: "group.week",
    label: "Class Situation (Week)",
    children: CLASS_SITUATION_WEEKS.map((week) => ({
      key: `group.week.${week.key}`,
      label: week.label,
      children: week.leaves.map((leaf) => ({
        key: weekColumnKey(week.key, leaf.label),
        label: leaf.label,
      })),
    })),
  },
  { key: "bookNeeded", label: "Book Needed" },
  { key: "koc", label: "KOC" },
  { key: "notes", label: "Notes" },
]

export const collectLeaves = (nodes) =>
  nodes.flatMap((node) => (node.children ? collectLeaves(node.children) : [node]))

export const ALL_COLUMN_KEYS = collectLeaves(CLASS_SITUATION_COLUMN_TREE).map((n) => n.key)
export const LOCKED_COLUMN_KEYS = collectLeaves(CLASS_SITUATION_COLUMN_TREE)
  .filter((n) => n.locked)
  .map((n) => n.key)
export const DEFAULT_HIDDEN_COLUMN_KEYS = ["center"]
